import { Datepicker } from "vanillajs-datepicker";

function roomsFilter() {
	const roomFilters = document.querySelectorAll('.block-rooms-filter');

	if(roomFilters) {
		roomFilters.forEach(roomFilter => {
				const filters = roomFilter.querySelectorAll('.block-rooms-filter__filter');
				const submitBtn = roomFilter.querySelector('.block-rooms-filter__submit > a');

				if (filters) {
					function getQueryString() {
						let count = 0;
						let string = '';
						// const urlBase = 'https://stay.wequassett.com/?_ga=2.172966251.932839084.1649271718-825333682.1619805003&currency=USD&hotel=27328&level=hotel&locale=en-US&shell=rHYAWI&template=rHYAWI&tps=fml';
						const urlBase = roomFilter.getAttribute('data-base-url');
						
						// let url = window.location.origin + window.location.pathname;
						// url = url.replace('#', '');

						filters.forEach(filter => {
							const input = filter.querySelector('input');
							const metaField = input.getAttribute('data-meta-field');
							//const seperator = count === 0 ? '?' : '&';
							const seperator = '&';
							let value = input.value;
							value = value.replaceAll('/', '-');

							string += `${seperator}${metaField}=${value}`;
							count++;
						});

						//window.location.href = urlBase+string;
						window.open(urlBase+string, '_blank');
					}

					filters.forEach(filter => {
						const minusBtn = filter.querySelector('.minus-icon');
						const plusBtn = filter.querySelector('.plus-icon');
						const numberInput = filter.querySelector('input[type="number"]');
						const numberMin = numberInput ? parseInt(numberInput.getAttribute('min')) : false;
						const textInput = filter.querySelector('input[type="text"]');

						if (minusBtn && plusBtn) {
							minusBtn.addEventListener('click', function() {
								let currentValue = parseInt(numberInput.value);

								if (currentValue > numberMin) {
									currentValue--;

									numberInput.setAttribute('value', currentValue);
								}
							});

							plusBtn.addEventListener('click', function() {
								let currentValue = parseInt(numberInput.value);
								currentValue++;

								numberInput.setAttribute('value', currentValue);
							});
						}

						if (textInput) {
							const datepicker = new Datepicker(textInput, {
								autohide: true
							});
						}
					});

					submitBtn.addEventListener('click', function(e) {
						e.preventDefault();
						getQueryString();
					});
				}
		});
	}
}

export default roomsFilter;